<section class="rcx-table">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body">
            <div class="row d-flex align-items-center">
              <div class="col-lg-auto">
                <h5 class="card-title m-0">
                  <i class="bx bx-spreadsheet me-1 text-primary"></i>Balance Sheet Reports
                </h5>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-auto">
                <div class="input-group">
                  <span class="input-group-text bg-primary" id="fromDate" ngbTooltip="Filter by From date."
                    placement="top" container="body">
                    <i class="bx bx-calendar-week"></i>
                  </span>
                  <input type="date" class="form-control border-start-0" id="fromDate" placeholder="From date..."
                    autocomplete="off" [(ngModel)]="fromDate">
                </div>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
                <div class="input-group">
                  <span class="input-group-text bg-primary" id="toDate" ngbTooltip="Filter by To date." placement="top"
                    container="body">
                    <i class="bx bx-calendar-week"></i>
                  </span>
                  <input type="date" class="form-control border-start-0" id="toDate" placeholder="To date..."
                    autocomplete="off" [(ngModel)]="toDate" [min]="fromDate">
                </div>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-2 d-flex align-items-center ps-1">
                <div class="input-group">
                  <button type="button" ngbTooltip="Fetch Records." placement="top" container="body"
                    style="font-size: 18px;" class="btn btn-secondary btn-sm" (click)="getBalanceSheetReport()">
                    <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                  </button>
                  <button type="button" ngbTooltip="Download as Excel" placement="top" container="body"
                    class="btn btn-success btn-sm ms-2" style="height: 2.3rem;" (click)="downloadExcel()">
                    <i class="bx bx-download ri-lg align-middle me-0"></i>
                  </button>
                </div>
              </div>
            </div>
            <table class="table" id="table">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="70">#</th>
                  <th scope="col" width="300">Liabilities</th>
                  <th scope="col" width="300" class="text-center">Amount</th>
                  <th scope="col" width="300">Assets</th>
                  <th scope="col" class="text-center">Amount</th>
                </tr>
              </thead>
              <tbody>
                <!-- Iterate over maxRows to ensure all entries are shown -->
                <tr *ngFor="let _ of [].constructor(maxRows); let i = index">
                  <td>{{ i + 1 }}.</td>
                  <!-- Liabilities -->
                  <ng-container
                    *ngIf="(balanceSheetReports.liabilities | keyvalue)[i] as liability; else emptyLiability">
                    <td>{{ liability.key }}</td>
                    <td class="text-center">{{ liability.value }}</td>
                  </ng-container>
                  <ng-template #emptyLiability>
                    <td>-</td>
                    <td class="text-center">-</td>
                  </ng-template>
                  <!-- Assets -->
                  <ng-container *ngIf="(balanceSheetReports.assets | keyvalue)[i] as asset; else emptyAsset">
                    <td>{{ asset.key }}</td>
                    <td class="text-center">{{ asset.value }}</td>
                  </ng-container>
                  <ng-template #emptyAsset>
                    <td>-</td>
                    <td class="text-center">-</td>
                  </ng-template>
                </tr>
                <!-- Totals -->
                <tr class="fw-bold">
                  <td></td>
                  <td class="text-end">Total Liabilities</td>
                  <td class="text-center">{{ balanceSheetReports.totalDebit }}</td>
                  <td class="text-end">Total Assets</td>
                  <td class="text-center">{{ balanceSheetReports.totalCredit }}</td>
                </tr>
                <!-- No Data or Loading -->
                <tr class="no-data">
                  <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="5">Fetching data, please wait...</td>
                  </ng-container>
                  <ng-template #noDataTemplate>
                    <ng-container *ngIf="maxRows === 0; else noSearchResults">
                      <td colspan="5">No balance sheet reports were found.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                      <td colspan="5"
                        *ngIf="searchKeyword && (balanceSheetReports.assets | keyvalue | search : 'key' : searchKeyword).length === 0 && (balanceSheetReports.liabilities | keyvalue | search : 'key' : searchKeyword).length === 0">
                        No balance sheet reports were found for the search results.
                      </td>
                    </ng-template>
                  </ng-template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>